import type { ReactNode } from 'react';
import { Icon } from '../Icon';
import styles from './styles.module.css';

export function LoadingIcon(): ReactNode {
  return (
    <div className={styles.LoaderIcon}>
      <Icon name="loading" />
    </div>
  );
}
